import { Zone } from '../../interfaces/zones';
import { zones } from '../../api/zones';

async function fetchZones(): Promise<Zone[]> {
	try {
		return await zones.getZones();
	} catch (error) {
		throw error;
	}
}

export const zoneService = {
	fetchZones,
};
